import React from 'react';
import { Card, TitleCard, HeaderCard, ContentCard, Button } from '@weezevent/nacre';
import { ZoneSelector } from '@weezevent/throne';
import { useTranslation } from 'react-i18next';
import Style from './zoneRightComponent.module.css';

export default function ZoneRightComponent({ parent, handleSubmit, handleSelectedZone, disableSave, clear, onCloseEditChart, loading }) {
    const { t } = useTranslation();

    return (
        <Card className={Style['zone-list']}>
            <HeaderCard separator={false}>
                <TitleCard title={t('ticket.charts.custom.chart.zones')} />
            </HeaderCard>
            <ContentCard className={Style['content']}>
                <ZoneSelector text={t('ticket.charts.custom.chart.zone-subtitle')} type="list" zone={parent} onZoneSelected={handleSelectedZone} display_back_button={false} />
            </ContentCard>
            <ContentCard>
                <Button fluid primary onClick={handleSubmit} disabled={disableSave} label={t('ticket.common.action.save')} isLoading={loading} />
                <Button fluid primary inverted onClick={() => clear(null)} label={t('ticket.charts.zone_editor.cta.clear')} />
                <Button fluid onClick={onCloseEditChart} label={t('ticket.common.action.cancel')} />
            </ContentCard>
        </Card>
    );
}
